import * as types from './actionTypes'

const INITIAL_STATE = JSON.parse(JSON.stringify({
  questions: {
    isLoading: false,
    data: {},
    error: null,
    receivedAt: null,
  },
  saveAnswers: {
    isLoading: false,
  },
  saveAnswersPsico: {
    isLoading: false,
  },
}))

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.REQUEST_QUESTIONS:
    case types.RECEIVE_QUESTIONS:
      return {
        ...state,
        questions: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.questions.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_SAVE_ANSWERS:
    case types.RECEIVE_SAVE_ANSWERS:
      return {
        ...state,
        saveAnswers: {
          isLoading: action.isLoading,
        }
      }
    case types.REQUEST_SAVE_ANSWERS_PSICO:
    case types.RECEIVE_SAVE_ANSWERS_PSICO:
      return {
        ...state,
        saveAnswersPsico: {
          isLoading: action.isLoading,
        }
      }
    default:
      return state
  }
}
